import { render, staticRenderFns } from "./Treatment.vue?vue&type=template&id=1b6a5a74&scoped=true"
import script from "@/views/Users/Student/Treatment.ts?vue&type=script&lang=ts&external"
export * from "@/views/Users/Student/Treatment.ts?vue&type=script&lang=ts&external"
import style0 from "@/views/Users/Student/treatment.scss?vue&type=style&index=0&id=1b6a5a74&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b6a5a74",
  null
  
)

export default component.exports